.root {
  position: relative;
  display: block !important;

  :global(.AnimatedSticker.not-shown) {
    display: block;
  }
}

.preview {
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  &:global(.closing) {
    transition-delay: 50ms;
  }
}

.textColorPreview {
  background-color: currentcolor;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
}
